import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * UC6 — confirmation before deleting a history record.
 */
@Component({
  selector: 'app-history-delete-confirm-modal',
  templateUrl: './history-delete-confirm-modal.component.html',
  styleUrls: ['./history-delete-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryDeleteConfirmModalComponent {
  @Input() fieldLabel: string;
  @Input() value: string;
  @Input() validFrom: string;

  constructor(public activeModal: NgbActiveModal) {}

  confirm(): void {
    this.activeModal.close(true);
  }
}
